import { createAction } from 'redux-actions';

export const searchWithdrawHistoryRequest = createAction('SEARCH_WITHDRAW_HISTORY_REQUEST');
export const searchWithdrawHistorySuccess = createAction('SEARCH_WITHDRAW_HISTORY_SUCCESS');
export const searchWithdrawHistoryFail = createAction('SEARCH_WITHDRAW_HISTORY_FAIL');

export const cleanupWithdrawalHistory = createAction('CLEANUP_WITHDRAWAL_HISTORY');
